import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';

import Icons from 'consts/icons';
import { postRequest } from 'helpers/apiRequests';
import { useLoginStyles } from 'consts/styles/Login';
import { useStyles } from 'components/common/components/modal/ConfirmationModalUseStyles';

const ConfirmationReset = props => {
  const classes = useStyles();
  const classesLogin = useLoginStyles();
  const { emailValue, setConfirm, language } = props;
  const [loading, setLoading] = React.useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState();

  const sendEmail = () => {
    setLoading(true);
    postRequest('resetPassword', {
      email: emailValue,
    }).then(result => {
      setLoading(false);
      if (result?.status === 200) setShowSuccessMessage(true);
      else {
        setShowSuccessMessage(false);
      }
    });
  };

  const handleLoading = !loading ? (
    language.resetPassword.emailPage.button_
  ) : (
    <div className={`${classesLogin.Login}__loader`}>
      <div className={`${classesLogin.Login}__loader__text`}>
        {language.resetPassword.emailPage.sending_}
      </div>
      <div className={`${classesLogin.Login}__loader__dot-flashing`}></div>
    </div>
  );

  const isResetConfirm = confirm => {
    if (confirm) return sendEmail();
    return setConfirm(false);
  };

  return (
    <div className={classes.ConfirmationModal}>
      <div
        className={`${classes.ConfirmationModal}__delete-form-container ${classes.ConfirmationModal}__delete-form-container__dimensions ${classes.ConfirmationModal}__delete-form-container__dimensions--small`}
      >
        <Grid
          className={`${classes.ConfirmationModal}__delete-form-container__row--height`}
          container
        >
          <div
            className={`${
              classes.ConfirmationModal
            }__delete-form-container__information-container
            ${showSuccessMessage === true &&
              `${classes.ConfirmationModal}__delete-form-container__icon--background-color--success`}
              ${showSuccessMessage === false &&
                `${classes.ConfirmationModal}__delete-form-container__icon--background-color--error`}`}
          >
            <div
              className={`${
                classes.ConfirmationModal
              }__delete-form-container__icon 
              ${showSuccessMessage === true &&
                `${classes.ConfirmationModal}__delete-form-container__icon--background-color--success`}
                ${showSuccessMessage === false &&
                  `${classes.ConfirmationModal}__delete-form-container__icon--background-color--error`}`}
            >
              <div
                className={`${classes.ConfirmationModal}__delete-form-container__icon__wrapper`}
              >
                {showSuccessMessage === undefined && (
                  <Icons.Navigation.ResetWarning
                    className={`${classes.ConfirmationModal}__delete-form-container__icon__header`}
                  />
                )}
                {showSuccessMessage === true && (
                  <Icons.Filters.ButtonLike
                    className={`${classes.ConfirmationModal}__delete-form-container__icon__header`}
                  />
                )}
                {showSuccessMessage === false && (
                  <Icons.Filters.ButtonDisLike
                    className={`${classes.ConfirmationModal}__delete-form-container__icon__header`}
                  />
                )}
              </div>
            </div>
          </div>

          {showSuccessMessage !== undefined ? (
            <>
              <Grid
                item
                xs={12}
                className={`${classes.ConfirmationModal}__delete-form-container__row--display ${classes.ConfirmationModal}__delete-form-container__row--height`}
              >
                <Typography align="center" variant="h2">
                  {showSuccessMessage
                    ? language.resetPassword.emailPage.successMsg_
                    : language.resetPassword.emailPage.faildMsg_}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button
                  className={`${classes.ConfirmationModal}__delete-form-container__button__pick`}
                  fullWidth
                  onClick={() => setConfirm(false)}
                >
                  {language.resetPassword.emailPage.close_}
                </Button>
              </Grid>
            </>
          ) : (
            <>
              <Grid
                item
                xs={12}
                className={`${classes.ConfirmationModal}__delete-form-container__row--display ${classes.ConfirmationModal}__delete-form-container__row--height`}
              >
                <Typography align="center" variant="h2">
                  {language.resetPassword.emailPage.confirmMsg_}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Button
                  className={`${classes.ConfirmationModal}__delete-form-container__button__pick`}
                  fullWidth
                  onClick={() => isResetConfirm(true)}
                >
                  {handleLoading}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  variant="contained"
                  disabled={loading}
                  className={`${classes.ConfirmationModal}__delete-form-container__button__pick`}
                  color="secondary"
                  onClick={() => isResetConfirm(false)}
                >
                  {language.resetPassword.emailPage.cancel_}
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </div>
    </div>
  );
};

ConfirmationReset.propTypes = {
  emailValue: PropTypes.string.isRequired,
  language: PropTypes.object.isRequired,
  setConfirm: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(ConfirmationReset);
